import { useState, useEffect, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Stack,
  Button,
  Popover,
  Box,
  Typography,
  TextField,
  Grid,
  Checkbox,
  Autocomplete, CircularProgress, Menu, Divider, MenuItem
} from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/material";
import { Collapse } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { Chip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Edit,
  Delete as DeleteIcon,
  Print,
  Visibility,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import {
  SalesOrderListApi,
  SalesOrderDelete,
  ApproveSo,
  DivisionList,
  SalesOrderExport
} from "../../../Services/Services";
import { Description as FileIcon } from "@mui/icons-material";
import InfiniteScroll from "react-infinite-scroll-component";
import { toast, ToastContainer } from "react-toastify";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import config from "../../../config";
import { generatePdf } from "../Sale/SalesOrderPrint";
pdfMake.vfs = pdfFonts.vfs;
// import { Tooltip } from "@mui/material";

export default function SalesOrderTable() {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedRow, setExpandedRow] = useState(null);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [orderToDelete, setOrderToDelete] = useState(null);
  const [salesOrders, setSalesOrders] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [approveAnchorEl, setApproveAnchorEl] = useState(null);
  const baseURL = config.staticBaseURL;
  const [soToApprove, setSoToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const [actionType, setActionType] = useState(null); // ✅ new state
  const [showRemarkForOrderId, setShowRemarkForOrderId] = useState(null);
  const userRole = localStorage.getItem("role");
  const [divisionLists, setDivisionLists] = useState([]);
  const [excelLoading, setExcelLoading] = useState(false);
  const [loading, setLoading] = useState(false); // For scroll pagination
const [filterLoading, setFilterLoading] = useState(false);
  const [filters, setFilters] = useState({

    project_name: "",
    party: "",
    division: "",
    date_range: "this_month",
  });
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [selectingDate, setSelectingDate] = useState(null);
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({ from: "", to: "" });
  const dateInputRef = useRef(null);
  const [customDateRange, setCustomDateRange] = useState({
    from: "",
    to: "",
  });
  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchOrders(1, true, filters);
    }, 500); // 500ms debounce

    return () => clearTimeout(handler);
  }, [filters]);
  useEffect(() => {
    const fetchData = async () => {
      const divisions = await DivisionList();
      setDivisionLists(divisions || []);
    };
    fetchData();
  }, []);
  const fetchOrders = async (
  pageNum = 1,
  reset = false,
  filterValues = filters
) => {
  try {
    // ✅ Use filterLoading for reset/filter changes, loading for scroll
    if (reset) {
      setFilterLoading(true);
    } else {
      setLoading(true);
    }

    // 🆕 Build params with custom date handling
    const params = { ...filterValues };

    // Add custom dates if custom range selected
    if (
      filterValues.date_range === "custom" &&
      customDateRange.from &&
      customDateRange.to
    ) {
      params.from_date = customDateRange.from;
      params.to_date = customDateRange.to;
    }

    const data = await SalesOrderListApi(pageNum, params);

    if (reset || pageNum === 1) {
      setSalesOrders(data.results);
    } else {
      setSalesOrders((prev) => [...prev, ...data.results]);
    }

    setHasMore(data.next !== null);
    setPage(pageNum);
  } catch (error) {
    console.error("❌ Failed to fetch sales orders:", error);
    toast.error("Failed to load sales orders");
  } finally {
    // ✅ Reset the appropriate loading state
    setFilterLoading(false);
    setLoading(false);
  }
};

  const handleExcelExport = async () => {
  if (salesOrders.length === 0) {
    toast.warning("No data available to export");
    return;
  }

  setExcelLoading(true);
  try {
    const blob = await SalesOrderExport(filters, customDateRange);

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Sales_Orders_${new Date().getTime()}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    toast.success('Excel downloaded successfully!');
  } catch (error) {
    console.error('Export error:', error);
    toast.error('Failed to export Excel');
  } finally {
    setExcelLoading(false);
  }
};

  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchOrders(nextPage);
  };

  const handleReset = () => {
    setFilters({
      project_name: "",
      party: "",
      division: "",
      date_range: "this_month",
    });
    setCustomDateRange({ from: "", to: "" });
    setTempCustomDateRange({ from: "", to: "" }); 
    setShowCustomDateInputs(false);
    setSelectingDate(null);
    setSalesOrders([]);
    setPage(1);
    setHasMore(true);
  };

  const handleClick = () => {
    navigate("/dashboard/saleorder");
  };

  const handleDelete = async (id) => {
    try {
      const response = await SalesOrderDelete(id); 

      if (response) {
        const updated = salesOrders.filter((s) => s.id !== id);
        setSalesOrders(updated);
      } else {
        console.warn("Failed to delete from API");
      }
    } catch (error) {
      console.error("Error deleting sales order:", error);
    }
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  const handleApprove = async (order, status, remarks = "") => {
    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const updated = await ApproveSo(
        order.id,
        approvedById,
        order.status,
        remarkInput
      ); // ✅ remarks bhi bhejna

      setSalesOrders((prev) =>
        prev.map((item) => (item.id === order.id ? updated : item))
      );

      toast.success(
        updated.status === "Approved"
          ? "SO approved successfully!"
          : "SO unapproved successfully!"
      );
    } catch (error) {
      console.error("Approval Toggle Error:", error);
      toast.error("Failed to toggle SO approval.");
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };
function formatOnlyDate(dateTimeString) {
  if (!dateTimeString) return "N/A";

  // Take only the date part (before T)
  const datePart = dateTimeString.split("T")[0];  // "2025-12-02"

  const [year, month, day] = datePart.split("-");

  return `${day}-${month}-${year}`;
}
  useEffect(() => {
    document.body.style.overflow = isMobile ? 'auto' : 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobile]);
  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday":
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      case "this_week":
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      case "previous_week":
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      case "this_month":
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      case "current_year":
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      case "financial_year":
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      default:
        return "";
    }
  };
  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  // ⭐ ADD THESE TWO FUNCTIONS AFTER formatDateDisplay

  // ✅ Apply Custom Date Range
  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({ ...tempCustomDateRange });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  // ✅ Cancel Custom Date Range
  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };

  return (
    <>
      {/* Filters + Button */}
      <Box
        display="flex"
        flexWrap="wrap"
        gap={2}
        alignItems="center"
        sx={{
          mt: -3,
          pt: 0,
          mb: 2,
        }}
      >
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={12} sm={2.5}>
            <TextField
              label="Date Range"
              value={
                filters.date_range === "custom" &&
                  customDateRange.from &&
                  customDateRange.to
                  ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
                  : filters.date_range === "today"
                    ? "Today"
                    : filters.date_range === "yesterday"
                      ? "Yesterday"
                      : filters.date_range === "this_week"
                        ? "This Week"
                        : filters.date_range === "previous_week"
                          ? "Previous Week"
                          : filters.date_range === "this_month"
                            ? "This Month"
                            : filters.date_range === "current_year"
                              ? "Current Year"
                              : filters.date_range === "financial_year"
                                ? "Financial Year"
                                : "Select Date Range"
              }
              onClick={(e) => setDateMenuAnchor(e.currentTarget)}
              size="small"
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              sx={{
                cursor: "pointer",
                "& .MuiInputBase-root": {
                  height: 35,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={2.5}>
            <TextField
              label="Search By Debtor."
              name="party"
              value={filters.party}
              onChange={handleFilterChange}
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 35,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
              fullWidth
            />
          </Grid>

          {/* <Grid item xs={12} sm={2.5}>
            <Autocomplete
              options={divisionLists || []}
              getOptionLabel={(opt) => opt?.division || ""}
              isOptionEqualToValue={(opt, val) =>
                opt.division_id === val?.division_id || opt.division_id === val
              }
              value={
                divisionLists.find(
                  (opt) => opt.division_id === filters.division
                ) || null
              }
              onChange={(e, newValue) =>
                setFilters((prev) => ({
                  ...prev,
                  division: newValue ? newValue.division_id : "",
                }))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Filter by Division"
                  variant="outlined"
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": { height: 35, borderRadius: 0 },
                    "& .MuiInputLabel-root": { fontSize: "0.7rem" },
                  }}
                />
              )}
            />
          </Grid> */}

          <Grid item xs={12} sm={2.5}>
            <TextField
              label="Search by Project Name"
              name="project_name"
              value={filters.project_name}
              onChange={handleFilterChange}
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 35,
                  borderRadius: 0,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={1}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleReset}
              sx={{
                height: "35px",
                whiteSpace: "nowrap",
                minWidth: "100px",
                borderRadius: "0",
                fontSize: "0.7rem",
              }}
              fullWidth
            >
              reset
            </Button>
          </Grid>

          <Grid item xs={12} sm={1}>
            <IconButton
              color="success"
              size="small"
              onClick={handleExcelExport}
              disabled={excelLoading || salesOrders.length === 0}
            >
              {excelLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <FileIcon fontSize="small" />
              )}
            </IconButton>
          </Grid>
        </Grid>

        {/* ⭐ REPLACE OLD MENU WITH THIS */}
        <Menu
          anchorEl={dateMenuAnchor}
          open={Boolean(dateMenuAnchor)}
          onClose={() => {
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
            setTempCustomDateRange({ from: "", to: "" });
          }}
          PaperProps={{
            sx: { width: 350, maxHeight: 500 },
          }}
        >
          {/* Quick Ranges */}
          {[
            { key: "today", label: "Today" },
            { key: "yesterday", label: "Yesterday" },
            { key: "this_week", label: "This Week" },
            { key: "previous_week", label: "Previous Week" },
            { key: "this_month", label: "This Month" },
            { key: "current_year", label: "Current Year" },
            { key: "financial_year", label: "Financial Year" },
          ].map((item) => (
            <MenuItem
              key={item.key}
              onClick={() => {
                setFilters((prev) => ({ ...prev, date_range: item.key }));
                setCustomDateRange({ from: "", to: "" });
                setDateMenuAnchor(null);
                setShowCustomDateInputs(false);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2">{item.label}</Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.7rem" }}
                >
                  {getDateRangeDisplay(item.key)}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider />

          {/* ✅ Custom Date Range - Expandable */}
          <MenuItem
            onClick={() => setShowCustomDateInputs((prev) => !prev)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
            >
              Custom Date Range
            </Typography>
            {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: "#f5f5f5",
                borderTop: "1px solid #e0e0e0",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mb: 1, display: "block" }}
              >
                Select Date Range
              </Typography>

              {/* From and To Date Inputs Side by Side */}
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.from}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max: tempCustomDateRange.to || undefined,
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.to}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempCustomDateRange.from || undefined,
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": {
                      height: 40,
                      fontSize: "0.75rem",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.75rem",
                    },
                  }}
                />
              </Box>

              {/* Selected Range Preview */}
              {tempCustomDateRange.from && tempCustomDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 1.5,
                    p: 1,
                    bgcolor: "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: "#2e7d32",
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                  {formatDateDisplay(tempCustomDateRange.to)}
                </Typography>
              )}

              {/* Apply and Cancel Buttons */}
              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelCustomDateRange}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApplyCustomDateRange}
                  disabled={
                    !tempCustomDateRange.from || !tempCustomDateRange.to
                  }
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Collapse>
        </Menu>
      </Box>

      <ToastContainer />

      <Box sx={{ position: "relative", flex: 1, minHeight: "400px" }}>
  
  {/* ✅ LOADING OVERLAY - Only shows for filter changes */}
  {filterLoading && (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        zIndex: 1000,
        borderRadius: 1,
      }}
    >
      <CircularProgress size={50} thickness={4} color="primary" />
      <Typography sx={{ mt: 2, color: "#333", fontWeight: 500 }}>
        {filters.date_range === "financial_year"
          ? "Loading Financial Year Data..."
          : filters.date_range === "current_year"
          ? "Loading Current Year Data..."
          : filters.date_range === "this_month"
          ? "Loading This Month Data..."
          : filters.date_range === "this_week"
          ? "Loading This Week Data..."
          : filters.date_range === "previous_week"
          ? "Loading Previous Week Data..."
          : filters.date_range === "custom"
          ? "Loading Custom Date Range..."
          : "Loading Data..."}
      </Typography>
      <Typography sx={{ mt: 0.5, color: "#666", fontSize: "0.8rem" }}>
        Please wait, this may take a moment
      </Typography>
    </Box>
  )}

      {isMobile ? (
        /* 📱 MOBILE VIEW - Expandable Cards */
        <Box>
          <InfiniteScroll
            dataLength={salesOrders.length}
            next={fetchMoreData}
            hasMore={hasMore}
            loader={
              <Typography align="center" sx={{ py: 2, fontSize: "0.75rem" }}>
                Loading...
              </Typography>
            }
            endMessage={
              <p style={{ textAlign: "center", fontSize: "0.75rem" }}>
                No more records!
              </p>
            }
          >
            {salesOrders.length === 0 ? (
              <Box
                sx={{
                  p: 3,
                  textAlign: "center",
                  bgcolor: "#f5f5f5",
                  borderRadius: 1,
                }}
              >
                <Typography sx={{ fontSize: "0.8rem", color: "text.secondary" }}>
                  No sales orders found
                </Typography>
              </Box>
            ) : (
              salesOrders.map((order, idx) => (
                <Box key={idx}>
                  {/* Main Card - Always Visible */}
                  <Box
                    onClick={() =>
                      setExpandedRow(expandedRow === idx ? null : idx)
                    }
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      p: 1.5,
                      cursor: "pointer",
                      bgcolor: idx % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:active": {
                        bgcolor: "#e3f2fd",
                      },
                      borderLeft: `4px solid ${order.status === "Approved"
                        ? "#4caf50"
                        : order.status === "Rejected"
                          ? "#f44336"
                          : "#ff9800"
                        }`,
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      {/* SO No & Status */}
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 0.5,
                        }}
                      >
                        <Typography
                          sx={{ fontSize: "0.75rem", fontWeight: "bold" }}
                        >
                          {order.so_no}
                        </Typography>
                        <Chip
                          label={
                            order.status === "Approved"
                              ? "Approved"
                              : order.status === "Rejected"
                                ? "Rejected"
                                : "Pending"
                          }
                          color={
                            order.status === "Approved"
                              ? "success"
                              : order.status === "Rejected"
                                ? "error"
                                : "warning"
                          }
                          size="small"
                          sx={{ fontSize: "0.6rem", height: 18 }}
                        />
                      </Box>

                      {/* Debtor Name */}
                      <Typography
                        sx={{ fontSize: "0.7rem", color: "#666", mb: 0.3 }}
                      >
                        {truncateText(
                          order.party_details?.company_name || "N/A",
                          25
                        )}
                      </Typography>

                      {/* Grand Total & Date */}
                      <Box
                        sx={{ display: "flex", gap: 1.5, alignItems: "center" }}
                      >
                        <Typography
                          sx={{
                            fontSize: "0.8rem",
                            fontWeight: "bold",
                            color: "primary.main",
                          }}
                        >
                          ₹
                          {order.grand_total
                            ? Number(order.grand_total).toLocaleString("en-IN")
                            : "0.00"}
                        </Typography>
                        <Typography sx={{ fontSize: "0.65rem", color: "#999" }}>
                          {new Date(order.order_date+ "T00:00:00").toLocaleDateString("en-GB")}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Expand Icon */}
                    <IconButton size="small" sx={{ ml: 1 }}>
                      {expandedRow === idx ? (
                        <ExpandLess fontSize="small" />
                      ) : (
                        <ExpandMore fontSize="small" />
                      )}
                    </IconButton>
                  </Box>

                  {/* Expanded Details */}
                  <Collapse in={expandedRow === idx} timeout="auto" unmountOnExit>
                    <Box
                      sx={{
                        px: 1.5,
                        py: 1,
                        bgcolor: idx % 2 === 0 ? "#f8f9fa" : "#fafafa",
                        borderLeft: `4px solid ${order.status === "Approved"
                          ? "#4caf50"
                          : order.status === "Rejected"
                            ? "#f44336"
                            : "#ff9800"
                          }`,
                      }}
                    >
                      {/* PO Details */}
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: 0.8,
                          mb: 0.8,
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{ fontSize: "0.6rem", color: "#999" }}
                          >
                            PO NO
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.72rem", fontWeight: 500 }}
                          >
                            {order.po_number || "N/A"}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{ fontSize: "0.6rem", color: "#999" }}
                          >
                            PO DATE
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.72rem", fontWeight: 500 }}
                          >
                            {new Date(order.order_date).toLocaleDateString(
                              "en-GB"
                            )}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Division & Project */}
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: 0.8,
                          mb: 0.8,
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{ fontSize: "0.6rem", color: "#999" }}
                          >
                            DIVISION
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.72rem", fontWeight: 500 }}
                          >
                            {order.division_name || "N/A"}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{ fontSize: "0.6rem", color: "#999" }}
                          >
                            PROJECT
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.72rem", fontWeight: 500 }}
                          >
                            {order.project_name || "N/A"}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Amount Details */}
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr",
                          gap: 0.8,
                          mb: 0.8,
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{ fontSize: "0.6rem", color: "#999" }}
                          >
                            GRAND TOTAL
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "primary.main",
                            }}
                          >
                            ₹
                            {order.grand_total
                              ? Number(order.grand_total).toLocaleString("en-IN")
                              : "0.00"}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{ fontSize: "0.6rem", color: "#999" }}
                          >
                            AD REC
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "success.main",
                            }}
                          >
                            ₹
                            {order.rec_amount
                              ? Number(order.rec_amount).toLocaleString("en-IN")
                              : "0.00"}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{ fontSize: "0.6rem", color: "#999" }}
                          >
                            BAL AMT
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.72rem",
                              fontWeight: 500,
                              color: "error.main",
                            }}
                          >
                            ₹
                            {(
                              Number(order.grand_total) -
                              Number(order.rec_amount)
                            ).toFixed(1)}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Created By & Approved By */}
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: 0.8,
                          mb: 0.8,
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{ fontSize: "0.6rem", color: "#999" }}
                          >
                            CREATED BY
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.72rem", fontWeight: 500 }}
                          >
                            {order.created_by_name || "N/A"}
                          </Typography>
                        </Box>
                        <Box>
                          <Typography
                            sx={{ fontSize: "0.6rem", color: "#999" }}
                          >
                            APPROVED BY
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.72rem", fontWeight: 500 }}
                          >
                            {order.approved_name || "N/A"}
                          </Typography>
                        </Box>
                      </Box>

                      {/* Remarks */}
                      {order.remarks && (
                        <Box sx={{ mb: 0.8 }}>
                          <Typography
                            sx={{ fontSize: "0.6rem", color: "#999" }}
                          >
                            REMARKS
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.72rem", fontWeight: 500 }}
                          >
                            {order.remarks}
                          </Typography>
                        </Box>
                      )}

                      {/* Actions */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          gap: 0.5,
                          pt: 1,
                          borderTop: "1px solid #e0e0e0",
                        }}
                      >
                        {order.project && (
                          <IconButton
                            size="small"
                            color="info"
                            onClick={(e) => {
                              e.stopPropagation();
                              window.open(`${order.project}`, "_blank");
                            }}
                            sx={{
                              bgcolor: "#e3f2fd",
                              borderRadius: "6px",
                              width: 32,
                              height: 32,
                              "&:hover": { bgcolor: "#bbdefb" },
                            }}
                          >
                            <Visibility sx={{ fontSize: "1rem" }} />
                          </IconButton>
                        )}

                        <IconButton
                          size="small"
                          color="default"
                          onClick={(e) => {
                            e.stopPropagation();
                            generatePdf(order);
                          }}
                          sx={{
                            bgcolor: "#f5f5f5",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": { bgcolor: "#e0e0e0" },
                          }}
                        >
                          <Print sx={{ fontSize: "1rem" }} />
                        </IconButton>
                      </Box>
                    </Box>
                  </Collapse>

                  <Divider />
                </Box>
              ))
            )}
          </InfiniteScroll>
        </Box>
      ) : (
        /* 💻 DESKTOP VIEW - Original Table */
        <InfiniteScroll
          dataLength={salesOrders.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={<h4>Loading...</h4>}
          endMessage={<p style={{ textAlign: "center" }}>No more records!</p>}
        >
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: "88vh",
              overflow: "auto",
            }}
          >
            <Table
              hover
              stickyHeader
              size="small"
              sx={{
                minWidth: "max-content",
                "& td, & th": {
                  borderBottom: "1px solid #ccc",
                  whiteSpace: "nowrap",
                },
              }}
            >
              <TableHead
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: "#f5f5f5",
                    "& th": {
                      fontWeight: "bold",
                      color: "#333",
                      borderBottom: "1px solid #999",
                      whiteSpace: "nowrap",
                    },
                  }}
                >
                  <TableCell align="center">S.No.</TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      minWidth: 100,
                      backgroundColor: "#fff",
                      zIndex: 3,
                    }}
                    align="center"
                  >
                    So. No.
                  </TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Debtor</TableCell>
                  <TableCell align="center">PO No</TableCell>
                  <TableCell align="center">PO Date</TableCell>
                  <TableCell align="center">Division</TableCell>
                  <TableCell align="center">Grand Total</TableCell>
                  <TableCell align="center">Project</TableCell>
                  <TableCell align="center">Ad Rec</TableCell>
                  <TableCell align="center">Bal Amt</TableCell>
                  <TableCell align="center">Approved By</TableCell>
                  <TableCell align="center">Created By</TableCell>
                  <TableCell align="center">Date</TableCell>
                  <TableCell align="center">Remarks</TableCell>
                  <TableCell
                    sx={{
                      position: "sticky",
                      right: 0,
                      minWidth: 140,
                      backgroundColor: "#fff",
                      zIndex: 3,
                    }}
                    align="center"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {salesOrders.map((order, idx) => {
                  const defaultBg = idx % 2 === 0 ? "#fafafa" : "#ffffff";
                  const hoverBg = "#e3f2fd ";
                  return (
                    <TableRow
                      hover
                      key={idx}
                      sx={{
                        backgroundColor: defaultBg,
                        "&:hover": {
                          backgroundColor: hoverBg,
                          "& td": {
                            backgroundColor: hoverBg,
                          },
                        },
                        "& td": {
                          paddingTop: "2px !important",
                          paddingBottom: "2px !important",
                          fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                          whiteSpace: "nowrap",
                        },
                      }}
                    >
                      <TableCell align="center">{idx + 1}</TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          left: 0,
                          minWidth: 100,
                          backgroundColor: defaultBg,
                          zIndex: 2,
                        }}
                        align="center"
                      >
                        {order.so_no}
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          label={
                            order.status === "Approved"
                              ? "Approved"
                              : order.status === "Rejected"
                                ? "Rejected"
                                : "Pending"
                          }
                          color={
                            order.status === "Approved"
                              ? "success"
                              : order.status === "Rejected"
                                ? "error"
                                : "warning"
                          }
                          variant="outlined"
                          size="small"
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip
                          title={order.party_details?.company_name}
                          arrow
                        >
                          <span>
                            {truncateText(
                              order.party_details?.company_name,
                              20
                            )}
                          </span>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">{order.po_number}</TableCell>
                      <TableCell align="center">
                        {new Date(order.order_date + "T00:00:00").toLocaleDateString("en-GB")}
                      </TableCell>
                      <TableCell align="center">{order.division_name}</TableCell>
                      <TableCell align="center">
                        {order.grand_total
                          ? Number(order.grand_total).toLocaleString("en-IN", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                          })
                          : "0.00"}
                      </TableCell>
                      <TableCell align="center">
                        {order.project_name || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {order.rec_amount
                          ? Number(order.rec_amount).toLocaleString("en-IN", {
                            minimumFractionDigits: 1,
                            maximumFractionDigits: 1,
                          })
                          : "0.00"}
                      </TableCell>
                      <TableCell align="center">
                        {(
                          Number(order.grand_total) - Number(order.rec_amount)
                        ).toFixed(1)}
                      </TableCell>
                      <TableCell align="center">{order.approved_name}</TableCell>
                      <TableCell align="center">
                        {order.created_by_name}
                      </TableCell>
                      <TableCell align="center">
                        {formatOnlyDate(order.created_at)}
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title={order.remarks} arrow>
                          <span>{truncateText(order.remarks, 20)}</span>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        sx={{
                          position: "sticky",
                          right: 0,
                          minWidth: 140,
                          backgroundColor: defaultBg,
                          zIndex: 2,
                        }}
                        align="center"
                      >
                        <span style={{ display: "inline-block", width: 40 }}>
                          {order.project ? (
                            <IconButton
                              sx={{
                                padding: 0,
                                paddingLeft: 1,
                                paddingRight: 1,
                              }}
                              size="small"
                              color="info"
                              onClick={() =>
                                window.open(`${order.project}`, "_blank")
                              }
                            >
                              <Visibility fontSize="small" />
                            </IconButton>
                          ) : (
                            <span
                              style={{ display: "inline-block", width: 40 }}
                            />
                          )}
                        </span>

                        <IconButton
                          sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                          size="small"
                          color="default"
                          onClick={() => generatePdf(order)}
                        >
                          <Print fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </InfiniteScroll>
      )}
      </Box>

      {/* Delete Confirmation Popover */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setOrderToDelete(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">
            Are you sure you want to delete this sales order?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                await handleDelete(orderToDelete);
                setAnchorEl(null);
                setOrderToDelete(null);
              }}
            >
              Yes
            </Button>
            <Button
              size="small"
              onClick={() => {
                setAnchorEl(null);
                setOrderToDelete(null);
              }}
            >
              No
            </Button>
          </Box>
        </Box>
      </Popover>

      {/* Approve/Reject Popover */}
      <Popover
        open={Boolean(approveAnchorEl)}
        anchorEl={approveAnchorEl}
        onClose={() => {
          setApproveAnchorEl(null);
          setSoToApprove(null);
          setRemarkInput("");
          setShowRemarkForOrderId(null);
          setActionType(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2, minWidth: 250 }}>
          {showRemarkForOrderId === soToApprove?.id ? (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Please enter remark before{" "}
                {actionType === "Approved" ? "approving" : "rejecting"}:
              </Typography>
              <TextField
                fullWidth
                size="small"
                value={remarkInput}
                onChange={(e) => setRemarkInput(e.target.value)}
                placeholder="Enter remark"
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color={actionType === "Approved" ? "success" : "error"}
                  size="small"
                  onClick={() => {
                    if (!remarkInput.trim()) {
                      toast.error("Remark is required!");
                      return;
                    }
                    handleApprove({
                      ...soToApprove,
                      status: actionType,
                      remarks: remarkInput,
                    });
                    setApproveAnchorEl(null);
                    setSoToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForOrderId(null);
                    setActionType(null);
                  }}
                >
                  Yes
                </Button>
                <Button
                  size="small"
                  onClick={() => {
                    setApproveAnchorEl(null);
                    setSoToApprove(null);
                    setRemarkInput("");
                    setShowRemarkForOrderId(null);
                    setActionType(null);
                  }}
                >
                  No
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Do you want to approve or reject this Sales order?
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Button
                  color="success"
                  size="small"
                  onClick={() => {
                    setShowRemarkForOrderId(soToApprove?.id);
                    setActionType("Approved");
                  }}
                >
                  Approve
                </Button>
                <Button
                  color="error"
                  size="small"
                  onClick={() => {
                    setShowRemarkForOrderId(soToApprove?.id);
                    setActionType("Rejected");
                  }}
                >
                  Reject
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Popover>
    </>
  );
}
